// @flow
import { boolean, string } from 'yup';
import {
  FLINK_WORKLOADS_INPUTS_DISPLAY_NAMES,
  FLINK_WORKLOADS_INPUTS_FIELDNAMES,
} from '@streaming-projects/orgs/enums';
import { convertConfigArrayToMap, createFormNameToFieldsMap } from '@src/configuration/utils';
import { clusterMonthlyDataInputTransformationFunc } from '@components/cluster/cluster-input-table/utils';
import { FORM_NAMES } from '@streaming-projects/enums';

export const FLINK_WORKLOAD_DETAILS_CONFIG = [
  {
    displayName: FLINK_WORKLOADS_INPUTS_DISPLAY_NAMES.WORKLOAD_NAME,
    backendFieldName: FLINK_WORKLOADS_INPUTS_FIELDNAMES.WORKLOAD_NAME,
    validation: string().label(FLINK_WORKLOADS_INPUTS_DISPLAY_NAMES.WORKLOAD_NAME).required(),
    belongingForm: FORM_NAMES.FLINK.WORKLOAD_DETAILS_FORM,
  },
  {
    displayName: FLINK_WORKLOADS_INPUTS_DISPLAY_NAMES.IS_ENABLED,
    backendFieldName: FLINK_WORKLOADS_INPUTS_FIELDNAMES.IS_ENABLED,
    validation: boolean().label(FLINK_WORKLOADS_INPUTS_DISPLAY_NAMES.IS_ENABLED).required(),
  },
  {
    displayName: FLINK_WORKLOADS_INPUTS_DISPLAY_NAMES.MONTHLY_INPUTS,
    backendFieldName: FLINK_WORKLOADS_INPUTS_FIELDNAMES.MONTHLY_INPUTS,
    inputTransformationFunc: clusterMonthlyDataInputTransformationFunc,
    belongingForm: FORM_NAMES.FLINK.WORKLOAD_MONTHLY_USAGE_FORM,
  },
];

export const FLINK_WORKLOAD_DETAILS_CONFIG_MAP = convertConfigArrayToMap(
  FLINK_WORKLOAD_DETAILS_CONFIG
);

export const FLINK_WORKLOAD_DETAILS_FORM_NAMES_TO_FIELDS_MAP = createFormNameToFieldsMap(
  FLINK_WORKLOAD_DETAILS_CONFIG
);
